<template>
  <div class="bg loginBg">
    <PwaInstall></PwaInstall>
    <div class="content">
      <div class="login-box" :class="{ 'ro-login': showRoLogin, 'ro-account-login': showRoLogin && showRoAccountLogin }">
        <div
          class="choose-game-title"
          :class="{ notShowSelectGame: !showSelectGame }"
        >
          <div class="left-container">
            <i
              class="back j-back-game-list"
              v-if="hasMutplGames || urlHasId || showRoAccountBind"
              @click="backSelectGame"
              v-show="
                (!showSelectGame && !urlHasId) ||
                (showUidTokenLogin && urlHasId) ||
                showRoAccountBind
              "
            ></i>
            <span
              v-show="
                !(
                  (!showSelectGame && !urlHasId) ||
                  (showUidTokenLogin && urlHasId)
                ) && !urlHasId
              "
            >
              {{ letter.creatework_gameHolder }}</span
            >
          </div>

          <div class="operation-container">
            <div
              class="language-select-container operation"
              v-if="showLanguageSelect"
            >
              <i class="icon-language"></i>
              <!-- <span class="language-text">{{ langList[lang] }}</span> -->
              <select
                ref="langSelect"
                class="language-select language-text j-lang-select"
                v-model="lang"
                pointClass="j-lang-select"
                selectClass="j-lang-select-ele"
                :style="{
                  width: `${langList[lang].length * 1 + 1}em`,
                  maxWidth: '7.5em'
                }"
              >
                <option
                  v-for="(text, lang) in langList"
                  :key="lang"
                  :value="lang"
                >
                  {{ text }}
                </option>
              </select>
              <!-- <i class="icon-select-down"></i> -->
            </div>
            <!-- TODO：真的有登出的逻辑在这里吗？ -->
            <div class="logout-container operation" v-show="false">
              <i class="icon-user"></i>
              <span>{{ letter.logout }}</span>
            </div>
          </div>
        </div>
        <div class="game-select-box" :class="[boxClassName]">
          <SelectGame
            :hideSomeGames="hideSomeGames"
            v-if="showSelectGame"
          ></SelectGame>
          <ThirdPartyLogin
            v-if="showThirdPartyLogin"
            @showPopup="showPopup"
          ></ThirdPartyLogin>
          <AccountLogin v-show="showAccoutLogin"></AccountLogin>
          <Register v-show="showRegister"></Register>
          <UidTokenLogin v-show="showUidTokenLogin"></UidTokenLogin>
          <RoAccountBind v-show="showRoAccountBind"></RoAccountBind>
          <RoLogin
            v-show="showRoLogin && !showRoAccountBind"
            @showPopup="showPopup"
          ></RoLogin>
        </div>
        <div
          class="showAllGame j-show-all-game"
          @click="hideSomeGames = false"
          v-if="showSelectGame && hideSomeGames"
          pointClass="j-show-all-game"
        >
          <span>{{ letter.moreGame }}</span>
          <i class="dropdown"></i>
        </div>
      </div>
    </div>
    <p v-if="!gymcGameInVn && !musVn" class="copyright" v-html="copyright"></p>
    <div class="link-box">
      <a
        v-if="showCustomize"
        class="customize-link"
        :href="`//gpassport.${mainHost}/center/JpServicePrivacy/customize?keyWord=ztmslgjppayzj`"
        target="_blank"
        >資金決済法に基づく表示</a
      >
      <a
        v-if="showCustomize"
        class="customize-link"
        :href="`//gpassport.${mainHost}/center/JpServicePrivacy/customize?keyWord=payquyin`"
        target="_blank"
        >特定商取引法に基づく表示</a
      >
      <a class="service-link" :href="serviceLink" target="_blank">{{
        letter.fwtk
      }}</a>
      <a class="policy-link" :href="privacyLink" target="_blank">{{
        letter.yszc
      }}</a>
    </div>
    <Popup
      @closePopup="closePopup"
      v-bind:title="popupTitle"
      v-bind:content="popupContent"
      v-bind:contentStyle="popupContentStyle"
      v-show="popupState"
    ></Popup>
    <transition name="fade">
      <LoaddingPage v-show="loadding"></LoaddingPage>
    </transition>
  </div>
</template>

<script>
import SelectGame from '../../components/webLogin/SelectGame.vue';
import ThirdPartyLogin from '../../components/webLogin/ThirdPartyLoginV3.vue';
// import AccountLogin from '../../components/webLogin/AccountLogin.vue';
import AccountLogin from '../../components/webLogin/AccountLoginV3.vue';
import Register from '../../components/webLogin/RegisterV3.vue';
import Popup from '../../components/webLogin/PopupV3.vue';
import { INIT_LOGO_BY_IP } from '../../store/logoConfig';
import { LOAD_SERVICE_STATUS } from '../../store/services';
import {
  UPDATE_GAME_LIST,
  UPDATE_GAMEID,
  SWITCH_LANGUAGE,
  JUDGE_IS_LOGIN,
  paramForward,
  GO_BACK_SELECT_GAME,
  UPDATE_THIRD_LIST,
  UPDATE_GAME_LOGIN_TYPE_BY_USERTYPE,
  GET_GAME_INFO,
  CHECK_GAME,
  JUDGE_FORWARD_IS_VERIFY,
  GO_BACK_SELECT_THIRD_PARTY_LOGIN,
  GET_USER_TOKEN
} from '../../store/web/login';
import { LANGUAGE_LOCALSTORGE_NAME } from '../../store/languages';
import globalConfig from '../../utiles/globalConfig';
import {
  reportActivityPoint,
  reportViewPage
} from '../../utiles/webLogin/activityPoint.js';
import {
  getCopyright,
  getPrivacyLink,
  getServiceLink
} from '../../utiles/reviewFooter';
// import { isPhone } from '../../utiles/device';
import { CHECK_IP_LOCATION } from '../../store/ipCheck';
// const imageMainHost = globalConfig.getImageMainHost();
// const showWebLogo = globalConfig.showWebLogo();
import UidTokenLogin from '../../components/webLogin/UidTokenLoginV3.vue';
import RoLogin from '../../components/webLogin/RoLogin.vue';
import RoAccountBind from '../../components/webLogin/RoAccountBind.vue';
import PwaInstall from '../../components/PwaInstall.vue';
const mainHost = globalConfig.getMainHost();

export default {
  name: 'loginPage',
  beforeCreate() {
    const primaryColor =
      mainHost === 'blancozone.com'
        ? '#8fbae7 '
        : mainHost === window.atob('MzdnYW1lcy5jb20=')
        ? '#00a3ff'
        : '#8356f5';
    document
      .getElementsByTagName('body')[0]
      .style.setProperty('--primaryColor', primaryColor);
    // 2024.07.26 邓智轩：页面链接没有p参数，ip为俄罗斯，页面增加参数p=rupay
    if (!globalConfig.getHrefParam('p')) {
      this.$store.dispatch(CHECK_IP_LOCATION).then(res => {
        if (res.ISO_TWO_CODE == 'RU') {
          const newHref = globalConfig.hrefAddParam(
            window.location.href,
            'p',
            'rupay'
          );
          window.location.href = newHref;
        }
      });
    }
    this.$store.dispatch(JUDGE_IS_LOGIN).then(res => {
      // 泰越斗罗h5：泰国地区域名跳转
      if (mainHost === atob('c2xmdW50YXAuY29t')) {
        this.$store.dispatch(CHECK_IP_LOCATION).then(res => {
          // 斗罗3D越泰百日活动页面登录，避免从slfuntap跳转到endomainname
          const gameId = globalConfig.getHrefParamUndecode('gameId');
          if (res.ISO_TWO_CODE == 'TH' && gameId != 274) {
            window.location.href = window.location.href.replace(
              new RegExp(atob('c2xmdW50YXAuY29t')),
              atob('ZW5kb21haW5uYW1lLmNvbQ==')
            );
          }
          this.$store.dispatch(INIT_LOGO_BY_IP);
        });
      } else {
        this.$store.dispatch(INIT_LOGO_BY_IP);
      }
      if (res) {
        let forward = globalConfig.getHrefParamUndecode('forward') || paramForward;
        let callerRedirectUrl = globalConfig.getHrefParam(
          'caller_redirect_url'
        );
        if (callerRedirectUrl) {
          forward = encodeURIComponent(callerRedirectUrl);
        }
        // 通过后端接口检测forward是否合规
        this.$store
          .dispatch(JUDGE_FORWARD_IS_VERIFY, forward)
          .then(res => {
            // res:校验forward是否合法：1合法，0不合法
            try {
              forward = decodeURIComponent(forward);
            } catch (error) {
              console.error('login_forward_decode_error', error);
            }
            // 检查是否有caller_redirect_url参数，论坛登录需要获取token
            if (callerRedirectUrl && +res) {
              // 如果有caller_redirect_url参数且forward校验通过，获取token并拼接到forward
              this.$store
                .dispatch(GET_USER_TOKEN, {})
                .then(token => {
                  if (token) {
                    // 如果token不为空，给forward拼上token参数
                    forward = globalConfig.hrefAddParam(
                      forward,
                      'token',
                      token
                    );
                  }
                  window.location.href = forward;
                })
                .catch(err => {
                  console.error('get_user_token_error!', err);
                  // token获取失败，直接跳转
                  window.location.href = forward;
                });
            } else {
              window.location.href = +res ? forward : paramForward;
            }
          })
          .catch(function (error) {
            console.log('error!', error);
            window.location.href = paramForward;
          });
      } else {
        this.loadding = true;
        let preGame =
          globalConfig.getHrefParamUndecode('gameId') ||
          globalConfig.getHrefParamUndecode('game_id');
        // 2025.08.13 李紫健：gnjoy.hk域名特殊处理，如果gameId为空，则提示缺少參數
        if ([window.atob('Z25qb3kuaGs='), window.atob('Z25qb3kuZ2FtZQ==')].includes(mainHost) && !preGame) {
          this.showPopup({
            title: this.letter.tips,
            content: this.letter.codeTip4
          });
          reportActivityPoint('view_page_fail', {
            eventType: 'custom_page_fail',
            eventValue: { msg: 'game_id_missing' }
          });
        }
        if (+preGame) {
          var __that = this;
          __that.$store
            .dispatch(CHECK_GAME, { gameId: preGame })
            .then(res => {
              __that.loadding = false;
              const userType = res?.gameInfo?.USER_TYPE;
              const isAllow = +res?.isAllow;
              if (isAllow) {
                __that.$store.dispatch(LOAD_SERVICE_STATUS, preGame);
                __that.$store
                  .dispatch(UPDATE_GAMEID, preGame)
                  .then(
                    __that.$store.dispatch(
                      UPDATE_GAME_LOGIN_TYPE_BY_USERTYPE,
                      userType
                    )
                  )
                  .then(__that.$store.dispatch(UPDATE_THIRD_LIST));
              } else {
                __that.$store.dispatch(GET_GAME_INFO, { gameID: preGame });
              }
            })
            .catch(err => {
              console.log(err);
              this.loadding = false;
            });
        } else {
          this.$store
            .dispatch(UPDATE_GAME_LIST, {})
            .then(() => {
              this.loadding = false;
            })
            .catch(err => {
              console.log(err);
              this.loadding = false;
            });
        }
      }
    });
  },

  data() {
    let gameId =
      globalConfig.getHrefParam('gameId') ||
      globalConfig.getHrefParam('game_id');
    let copyright =
      gameId == 215
        ? `© Copyright Bản quyền thuộc về Sungame Group`
        : `COPYRIGHT © ${location.host.toUpperCase()} ALL RIGHTS RESERVED.`;
    // 2024.07.23 邓智轩：智聪域名的第三方支付页特殊处理
    // 2024.07.26 邓智轩：参数p=rupay时，特殊处理
    if (
      globalConfig.getMainHost() === 'wisdomentertainmen.com' ||
      globalConfig.getHrefParam('p') === 'rupay'
    ) {
      copyright = `COPYRIGHT © 2024 G-CONG NETWORK TECHNOLOGY CO.LIMITED ALL RIGHTS RESERVED.`;
    }
    copyright = getCopyright(gameId) || copyright;
    // 2024.08.01 邓智轩：参数p=wisdom时，特殊处理
    if (
      globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
      globalConfig.getHrefParam('p') === 'wisdom'
    ) {
      copyright = `COPYRIGHT © WISDOM ENTERTAINMENT ONLINE INTERNATIONAL LIMITED ALL RIGHTS RESERVED.<br>RM 703, 7/F KLN BLDG 555 NATHAN RD KL,Hong Kong,999077`;
    }
    // 2024.08.07 邓智轩：参数p=jppay时，修改页脚主体信息
    if (
      globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
      globalConfig.getHrefParam('p') === 'jppay'
    ) {
      copyright = `COPYRIGHT © 37ゲームズジャパン株式会社 ALL RIGHTS RESERVED.`;
    }
    // 2025.08.25 李紫健：gnjoy.hk域名特殊处理，不显示语言选择（456 除外，与 gnjoy.game 一致）

    return {
      popupState: false,
      popupTitle: '',
      popupContent: '',
      popupContentStyle: '',
      gymcGameInVn: gameId == 125 || this.$store.state.gameId == 125,
      // 鬼語&越南語 显示 100d品牌100d品牌
      urlHasId: globalConfig.getHrefParamUndecode('gameId'),
      copyright: copyright,
      // 根据域名判断是否展示logo
      loadding: false,
      hideSomeGames: false,
      musVn:
        globalConfig.getHrefParam('gameId') == 201 ||
        globalConfig.getHrefParam('game_id') == 201 ||
        this.$store.state.gameId == 201
    };
  },
  computed: {
    showLanguageSelect() {
      if (globalConfig.getMainHost() !== 'gnjoy.hk') {
        return true;
      }
      const gameId =
        this.$store.state.gameId ||
        globalConfig.getHrefParam('gameId') ||
        globalConfig.getHrefParam('game_id');
      return +gameId === 456;
    },
    boolBlancozone() {
      return /blancozone.com/.test(window.location.host);
    },
    lang: {
      get() {
        return this.$store.state.lang;
      },
      set(val) {
        globalConfig.setLclStorageItem(LANGUAGE_LOCALSTORGE_NAME, val);
        this.$store.dispatch(SWITCH_LANGUAGE, val);
      }
    },
    isJp() {
      // 判断是否为日本地区
      const iso_two_code =
        localStorage &&
        typeof localStorage.getItem === 'function' &&
        localStorage.getItem('locationDetectByIP') &&
        JSON.parse(localStorage.getItem('locationDetectByIP')); // 根据 IP 获取地区码
      const area = iso_two_code && iso_two_code['ISO_TWO_CODE'];
      return area === 'JP' || globalConfig.getLanguages() === 'ja-JP';
    },
    logoUrl() {
      return this.$store.state.logoConfig.webLoginLogo;
    },
    showLogo() {
      return this.$store.state.logoConfig.showWebLoginLogo;
    },
    letter() {
      return this.$store.state.letter;
    },
    langList() {
      return this.$store.state.langList;
    },
    showSelectGame() {
      // 2025.08.13 李紫健：gnjoy.hk域名特殊处理，如果gameId为空，则不显示选择游戏页面
      if ([window.atob('Z25qb3kuaGs='), window.atob('Z25qb3kuZ2FtZQ==')].includes(mainHost) && !this.$store.state.gameId) {
        return false;
      }
      return !this.$store.state.gameId;
    },
    showThirdPartyLogin() {
      return this.$store.state.gameId && this.$store.state.isThirdPartyLogin;
    },
    showAccoutLogin() {
      return this.$store.state.gameId && this.$store.state.isAccoutLogin;
    },
    showRegister() {
      return this.$store.state.gameId && this.$store.state.isRegister;
    },
    showUidTokenLogin() {
      return this.$store.state.gameId && this.$store.state.isUidTokenLogin;
    },
    showRoLogin() {
      return this.$store.state.gameId && this.$store.state.isRoLogin;
    },
    showRoAccountLogin() {
      return globalConfig.getHrefParam('isOpenAccount') === '1';
    },
    showRoAccountBind() {
      return (
        this.$store.state.gameId &&
        globalConfig.getHrefParam('migrateLoginToken')
      );
    },
    boxClassName() {
      return this.showUidTokenLogin
        ? 'step-box login-width uid'
        : this.$store.state.gameId
        ? 'step-box login-width'
        : 'step-box select-game-width';
    },
    hasMutplGames() {
      let gameList = this.$store.state.gameList;
      let totleLen = Object.keys(gameList).length;
      if (totleLen > 8) {
        this.hideSomeGames = true;
      }
      return totleLen > 1;
    },
    serviceLink() {
      const reviewServiceLink = getServiceLink(this.$store.state.gameId);
      if (reviewServiceLink) {
        return reviewServiceLink;
      }
      // 2024.08.07 邓智轩：带参数p=jppay时替换服务条款链接
      if (
        globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
        globalConfig.getHrefParam('p') === 'jppay'
      ) {
        return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/JpServicePrivacy/customize?keyWord=service_pnsjppay`;
      }
      // 2024.08.01 邓智轩：参数p=wisdom时，特殊处理
      if (
        globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
        globalConfig.getHrefParam('p') === 'wisdom'
      ) {
        return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/ServicePrivacy/customize?keyWord=service_wisdom`;
      }
      // 2024.07.26 邓智轩：参数p=rupay时，特殊处理
      if (globalConfig.getHrefParam('p') === 'rupay') {
        return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/ServicePrivacy/customize?keyWord=service_paycomp`;
      }
      // 2024.07.23 邓智轩：智聪域名的第三方支付页替换服务条款链接
      if (globalConfig.getMainHost() === 'wisdomentertainmen.com') {
        return '//www.gcongnetwork.com/term.html';
      }
      // 2026.01.14 登录页判断gameId=386则拼接gameId=386到链接
      if (this.$store.state.gameId == 386) {
        return `//gpassport.${globalConfig.getMainHost()}/center/ServicePrivacy/service?gameId=386`;
      }
      // 2026.05.13 登录页判断gameId=456则跳转RO东南亚协议
      if (this.$store.state.gameId == 456) {
        return `https://www.gnjoy.hk/Terms`;
      }
      return `//gpassport.${globalConfig.getMainHost()}/center/${
        this.isJp ? 'Jp' : ''
      }ServicePrivacy/service`;
    },
    privacyLink() {
      const reviewPrivacyLink = getPrivacyLink(this.$store.state.gameId);
      if (reviewPrivacyLink) {
        return reviewPrivacyLink;
      }
      // 2024.08.01 邓智轩：参数p=wisdom时，特殊处理
      if (
        globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
        globalConfig.getHrefParam('p') === 'wisdom'
      ) {
        return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/ServicePrivacy/customize?keyWord=privacy_wisdom`;
      }
      // 2024.07.26 邓智轩：参数p=rupay时，特殊处理
      if (globalConfig.getHrefParam('p') === 'rupay') {
        return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/ServicePrivacy/customize?keyWord=privacy_paycomp`;
      }
      // 2024.07.23 邓智轩：智聪域名的第三方支付页替换隐私协议链接
      if (globalConfig.getMainHost() === 'wisdomentertainmen.com') {
        return '//www.gcongnetwork.com/privacy.html';
      }
      // 2023.11.15 邓智轩：PNS（191）带参数p=payermax时替换隐私协议
      if (
        this.$store.state.gameId == 191 &&
        globalConfig.getHrefParam('p') == 'payermax'
      ) {
        return `https://gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/ServicePrivacy/customize?keyWord=privacy_paycomp`;
      }
      // 2026.01.14 登录页判断gameId=386则拼接gameId=386到链接
      if (this.$store.state.gameId == 386) {
        return `//gpassport.${globalConfig.getMainHost()}/center/ServicePrivacy/privacy?gameId=386`;
      }
      // 2026.05.13 登录页判断gameId=456则跳转RO东南亚协议
      if (this.$store.state.gameId == 456) {
        return `https://www.gnjoy.hk/Policies`;
      }
      return `//gpassport.${globalConfig.getMainHost()}/center/${
        this.isJp ? 'Jp' : ''
      }ServicePrivacy/privacy`;
    },
    showCustomize() {
      // 2024.08.07 邓智轩：带参数p=jppay时增加两个日本协议显示
      return (
        globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
        globalConfig.getHrefParam('p') === 'jppay'
      );
    }
  },
  methods: {
    switchLang(lang) {
      this.$store.dispatch(SWITCH_LANGUAGE, lang);
    },
    closePopup() {
      this.popupState = false;
    },
    showPopup(param) {
      if (param.title !== undefined && param.content) {
        this.popupTitle = param.title;
        this.popupContent = param.content;
        this.popupState = true;
        this.popupContentStyle = param.contentStyle || {};
      }
    },
    backSelectGame() {
      if (this.showRoAccountBind) {
        // 若为RO绑定界面，返回则移除链接的migrateLoginToken参数回到登录页
        const url = new URL(window.location.href);
        url.searchParams.delete('migrateLoginToken');
        window.location.href = url.toString();
        return;
      }
      if (this.showUidTokenLogin) {
        this.$store.commit(GO_BACK_SELECT_THIRD_PARTY_LOGIN);
      } else {
        this.$store.dispatch(GO_BACK_SELECT_GAME);
      }
    },
    showAllGames() {
      this.hideSomeGames = false;
    }
  },
  mounted() {
    // EventBus.$on("updateLogo", gameid => {
    //   // 3syua的logo是游戏logo，现在上了新游戏有锅了要隐藏
    //   let imh = globalConfig.getImageMainHost(gameid);
    //   this.logoUrl = imh === '3syua.com' ? "" : `https://abres.octlib.com/platformIcon/brandText/${imh}.png`;
    // });
    reportViewPage(this.$store.state.gameId);
  },
  components: {
    SelectGame,
    ThirdPartyLogin,
    AccountLogin,
    Register,
    Popup,
    UidTokenLogin,
    PwaInstall,
    RoLogin,
    RoAccountBind
  }
};
</script>
<style lang="scss">
// @import '../../assets/scss/platform-webStore.scss';
</style>
<style lang="scss" scoped>
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/base.scss';
@import '../../assets/scss/webLogin-v3.scss';

.notShowSelectGame {
  margin: 0 !important;
  border: none !important;
  padding-bottom: 2.87vh !important;
}
/*!rtl:raw:
.back {
  transform: scaleX(-1);
}
*/

.select {
  position: absolute;
  outline: none;
  top: -6vh;
  right: 0;
  width: 16.3vh;
  min-width: 24%;
  height: 4vh;
  line-height: 4vh;
  font-size: 1.8vh;
  //color: $fontgrey;
  padding-left: 2vh;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid white;
  cursor: pointer;
}

.list {
  position: absolute;
  font-size: 0;
}

.tra {
  background: url($imgSupport + 'tra.png') no-repeat center center;
  background-size: contain;
  position: absolute;
  width: 1.4vh;
  height: 1vh;
  top: -4.4vh;
  right: 1vh;
}
.bg-huawens {
  position: absolute;
}
</style>
